// 消息通知 - ID
export const NOTICE_ID = 'idt_notice_id'
// 消息通知 - STATUS
export const NOTICE_STATUS = 'idt_notice_status'
/** 百度地图AK */
export const BAIDU_MAP_AK = 'dcALz3nkG8E4tIZwsrKWUtzAqZeIQoXi'